import { render, staticRenderFns } from "./TabProductDetail.vue?vue&type=template&id=5f7e0930&"
import script from "./TabProductDetail.vue?vue&type=script&lang=js&"
export * from "./TabProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./TabProductDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports